import { CalendarService } from '@b2b/common/services/calendar';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { input, TODO } from '@b2b/types/core';
import angular, { IOnChangesObject } from 'angular';

class FormatTimeController {
  static $inject = ['$element', 'CalendarService', 'UserPreferencesService', 'HelpersService'];

  date = input<Date | string>();
  fallback = input<string>();
  format = input<string>();

  formattedTime = '';

  constructor(
    private $element: JQuery,
    private calendarService: CalendarService,
    private userPreferencesService: UserPreferencesService,
    private helpersService: TODO,
  ) {}

  $onInit() {
    this.$element.addClass('acme-format-time');
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.time || changes.format) {
      this.updateFormattedTime();
    }
  }

  private updateFormattedTime() {
    if (!this.date) {
      this.formattedTime = this.fallback ?? '';
      return;
    }

    // Get the format from user preferences or use the provided format
    const timeFormat = this.getResolvedFormat();

    // Parse the time if it's a string, otherwise use it directly
    const parsedTime = typeof this.date === 'string' ? this.calendarService.parseDate(this.date) : this.date;

    this.formattedTime = this.calendarService.toFormat(parsedTime, timeFormat);
  }

  private getResolvedFormat(): string {
    if (!this.format) {
      // Default to standardTime format
      return this.userPreferencesService.getDateFormat('standardTime', 'hourFormat');
    }

    // Check if the format is a known format key in HelpersService.dateFormats
    const helperFormat = this.helpersService.dateFormats[this.format];

    if (helperFormat) {
      // Use user preferences for known format types
      return this.userPreferencesService.getDateFormat(this.format, 'hourFormat');
    }

    // Otherwise, use the format string directly
    return this.format;
  }
}

export const FormatTimeComponentModule = angular
  .module('acme.common.component.format-time', [
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.helpers',
  ])
  .component('acmeFormatTime', {
    templateUrl: 'common/components/format-time/format-time.component.tpl.html',
    controller: FormatTimeController,
    controllerAs: '$ctrl',
    bindings: {
      date: '<',
      format: '<',
      fallback: '<',
    },
  }).name;
